<template lang="pug">
    #app
        EventSingle(v-if="!registered.event")
        div(v-if="registered.event")
            Confirm

</template>

<script>
import FullView from './components/EventDisplayFull.vue'
import Confirm from './components/Confirm.vue'

export default {
    name: 'app',

    mounted() {
        let currentUrl = window.location.href.split("/")

        this.$store.dispatch({
            type: 'appLoadPipelineSingleEvent',
            url: currentUrl[currentUrl.length-1],
        })
    },

    components: {
        EventSingle: FullView,
        Confirm,
    },


    computed: {
        registered() {
            return this.$store.getters.registered
        }
    }
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// src/App.vue